var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChartSimple = function SvgChartSimple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6877 2C13.8678 2 14.8253 2.95938 14.8253 4.14286V19.8571C14.8253 21.0402 13.8678 22 12.6877 22H11.2627C10.0826 22 9.12516 21.0402 9.12516 19.8571V4.14286C9.12516 2.95938 10.0826 2 11.2627 2H12.6877ZM12.6877 4.14286H11.2627V19.8571H12.6877V4.14286ZM5.56258 10.5714C6.74269 10.5714 7.70013 11.5313 7.70013 12.7143V19.8571C7.70013 21.0402 6.74269 22 5.56258 22H4.13755C2.957 22 2 21.0402 2 19.8571V12.7143C2 11.5313 2.957 10.5714 4.13755 10.5714H5.56258ZM5.56258 12.7143H4.13755V19.8571H5.56258V12.7143ZM16.2503 7C16.2503 5.81696 17.2078 4.85714 18.3879 4.85714H19.8129C20.993 4.85714 21.9505 5.81696 21.9505 7V19.8571C21.9505 21.0402 20.993 22 19.8129 22H18.3879C17.2078 22 16.2503 21.0402 16.2503 19.8571V7ZM18.3879 19.8571H19.8129V7H18.3879V19.8571Z",
    fill: "#555"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChartSimple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart-simple.529e318f.svg";
export { ForwardRef as ReactComponent };